export default {
  bot_name: 'Bot',
  customer_name: 'Cliente',
  priority: 'Prioridad',
  queue_time: 'Tiempo en la fila',
  sequential_id: 'Ticket',
  team: 'Fila',
};
